import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";


const styles = {
  menuBtn: {
    maxWidth: "400px",
    boxShadow: "none",
    padding: "16px 32px",
    margin: "5px 5px",
    backgroundColor: "#3EB3BC",
    textTransform: "none",
    flexGrow: "1",
    height: "60px",
    "&:hover": {
      backgroundColor: "#3EB3BC",
      boxShadow: "none",
    },
    "&:disabled": {
      backgroundColor: "#dddddd",
    },
  },
  typography: {
    textAlign: "center",
    textTransform: "none",
    whiteSpace: "pre-line",
  },
};

export const NextButton = ({ title, path = undefined, disabled = false, onClick = undefined }) => {

  return (
    <Button
      disabled={disabled}
      fullWidth
      component={path ? Link : "button"}
      to={path}
      onClick={onClick}
      sx={styles.menuBtn}
      variant="contained"
      type="button"
      size="large"
      color="primary"
    >
      <Typography
        variant="h6"
        sx={styles.typography}
      >
        {title}
      </Typography>
    </Button>
  );
};

NextButton.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};